import { LoadRouteList } from '@/javascript/domain/usecases/maps/load-route-list'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { RouteItem } from '@/javascript/domain/entities/maps/route-item'
import { HttpClient, HttpStatusCode } from '@/javascript/data/protocols/http'
import { RemoteRouteItem } from '@/javascript/data/entities/maps/remote-route-item'
import { ListMapper } from '@/javascript/infra/mappers/mapper'

export class RemoteLoadRouteList implements LoadRouteList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadRouteList.Response>,
    private readonly routeMapper: ListMapper<RouteItem, RemoteRouteItem>
  ) {}

  async load (params?: LoadRouteList.Params): Promise<RouteItem[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: { date: params?.date?.toISOString() }
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok: return this.routeMapper.toEntityList(response?.results) ?? []
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

namespace RemoteLoadRouteList {
  export type Response = {
    results?: RemoteRouteItem[]
  }
}
